import i18n from '../i18n';
import Axios from "axios";
import qs from 'qs';
import store from "./store";
import C, {IS_OFFLINE_MODE} from "./constant"
import Perference from './perference';
const util = require('util');
import MyInfo from "./MyInfo";

let isShow = false;
export default {
  request: function(url, method, data=null, showLoading=true){
    let headers = {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      'Accept': 'application/json',
      'Access-Control-Allow-Origin': '*',
      "Access-Control-Allow-Methods":'*',
      'X-Requested-With': 'XMLHttpRequest',
  //    'App-Package': DeviceInfo.getBundleId(),
  //    'App-Version-Name': DeviceInfo.getVersion(),
  //    'App-Version-Code': DeviceInfo.getBuildNumber(),
  //    'App-Device': Platform.OS === 'android' ? 'android' : 'ios',
      'App-Did': Perference.uuid(),
      'App-Access-Token': MyInfo.accessToken,
      // 'App-Access-Token': store.getters.accessToken,
    };
    store.commit('setLoading', showLoading);
    return new Promise((resolve, reject) => {
      Axios.request({
        url: C.API_URL + url,
        method: method,
        headers: headers,
        params: method === 'GET' ? data : null,
        data: method === 'POST' ? qs.stringify(data) : null,
      }).then(response => {
        store.commit('setLoading', false);
        if (response.data.code == C.API_RES_CODE.ERR_OTHER_DEVICE_LOGIN) {
          store.commit('setLogOutNeed', true);
        }
        resolve(response.data);
      }).catch(err => {
        store.commit('setLoading', false);
        reject(err);
      });
    });
  },

  request2: function(url, method, data=null, showLoading=true){
    let headers = {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      'Accept': 'application/json',
    };
    store.commit('setLoading', showLoading);
    return new Promise((resolve, reject) => {
      Axios.request({
        url: url,
        method: method,
        headers: headers,
        params: method === 'GET' ? data : null,
        data: method === 'POST' ? qs.stringify(data) : null,
      }).then(response => {
        store.commit('setLoading', false);
        if (response.data.code == C.API_RES_CODE.ERR_OTHER_DEVICE_LOGIN) {
          store.commit('setLogOutNeed', true);
        }
        resolve(response.data);
      }).catch(err => {
        store.commit('setLoading', false);
        reject(err);
      });
    });
  },

  requestPost: function(url, data=null, showLoading=true) {
    return this.request(url, 'POST', data, showLoading);
  },

  requestGet: function(url, data=null, showLoading=true) {
    return this.request(url, 'GET', data, showLoading);
  },

  requestGet2: function(url, data=null, showLoading=true) {
    return this.request2(url, 'GET', data, showLoading);
  },

  downloadItem (url, label) {
    Axios.get(url,
      {
        responseType: 'blob'
    })
      .then(response => {
        const blob = new Blob([response.data], { type: 'application/*' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = label
        link.click()
        URL.revokeObjectURL(link.href)
      }).catch(console.error)
  },

  downloadExcel (url, label) {
    Axios.get(url,
      {
        responseType: 'blob'
    })
      .then(response => {
        const blob = new Blob([response.data], { type: 'application/*' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = label
        link.click()
        URL.revokeObjectURL(link.href)
      }).catch(console.error)
  },

  requestUpload: function (context, url, file, category) {
    var finalUrl = url;
    if (file !== undefined){
      var self = this;
      return new Promise((resolve, reject) => {
        let formData = new FormData();
        formData.append('category', category);
        if (file.constructor.name === 'Array'){
          file.map(it => {
            formData.append('files[]', it);
          })
          finalUrl = finalUrl + "s";
        } else {
          formData.append('file', file);
        }
        let headers = {
          // 'Content-Type': 'multipart/form-data',
          'Accept': 'application/json',
          // 'App-Package': IS_OFFLINE_MODE ? 'com.made' : DeviceInfo.getInstallerPackageName(),
          // 'App-Version-Name': DeviceInfo.getVersion(),
          // 'App-Version-Code': DeviceInfo.getBuildNumber(),
          // 'App-Device': Platform.OS === 'android' ? 'android' : 'ios',
          'App-Did': Perference.uuid(),
          'App-Access-Token': MyInfo.accessToken,
          // 'App-Access-Token': store.getters.accessToken,
        };

        store.commit('setLoading', true);

        Axios.post(C.API_URL + finalUrl, formData, headers).then(function (response) {
          store.commit('setLoading', false);
          console.log(response.data);
          var result = response.data;
          // if (result.code !== C.API_RES_CODE.SUCCESS) {
          //   self.showConfirm(
          //     context,
          //     i18n.t('app_error.network'),
          //   ).then(value => {
          //     if(value){
          //       self.requestUpload(context, url,file,category);
          //     }
          //   });
          // }
          resolve(result);
        })
          .catch(function (error) {
            store.commit('setLoading', false);
            self.showConfirm(
              context,
              i18n.t('app_error.network'),
            ).then(value => {
              if(value){
                self.requestUpload(context, url,file,category);
              }
            });
            reject(error);
            throw Error(error);
          });
      });
    }
    },

  formatTime: function(secs) {
    if (secs % 60 >= 10)
      return '0' + Math.floor(secs/60) + ':' + secs%60;
    else
      return '0' + Math.floor(secs/60) + ':0' + secs%60;
  },

  formatNumber: function(value) {
     return value.toString().replace(/,/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },

  currency(value) {
    return value.toString().replace(/,/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },

  currency_kilo_10000: function(value) {
    if (i18n.locale == 'en')
      return util.format(i18n.t('common.k'), this.formatNumber(value));
    else
      return util.format(i18n.t('common.k'), this.formatNumber(value/10));
  },

  currency_baek_10000: function(value) {
    let currency = Number(value) * 100;
    if (isNaN(currency)) {
      return value;
    }
    return util.format(i18n.t('common.man_won'), this.formatNumber(currency));
  },

  currency_10000: function(value) {
    if (value == undefined)
      return util.format(i18n.t('common.man_won'), this.currency(0));
    let currency = Number(value);
    if (isNaN(currency)) {
      return value;
    }
    return util.format(i18n.t('common.man_won'), this.formatNumber(currency));
  },

  calcPyong: function(strSquare) {
    let pyong = parseFloat(Number(strSquare) / 3.305787);
    if (pyong - parseFloat(pyong.toFixed(2)) >= 0.0045) {
      pyong = (parseFloat(pyong.toFixed(2)) + 0.01).toFixed(2);
    } else {
      pyong = pyong.toFixed(2);
    }
    return pyong;
  },

  calcSquare: function(strPyong) {
    let square = Number(strPyong) * 3.305787;
    if (square - parseFloat(square.toFixed(2)) >= 0.0045) {
      square = (parseFloat(square.toFixed(2)) + 0.01).toFixed(2);
    } else {
      square = square.toFixed(2);
    }
    return square;
  },

  calcRound2: function(num) {
    return (Math.round(num * 100) / 100).toFixed(2);
  },
  changeDateFormat: function(date) {
    return date.substr(0, 4) + ". " + date.substr(4, 2) + ". " + date.substr(6, 2);
  },
  changeDateFormat2: function(date) {
    return date.substr(0, 4) + ". " + date.substr(4, 2);
  },
  changeDateFormat3: function(date) {
    return date.substr(0, 4) + "년 " + date.substr(4, 2) + "월";
  },

  toast(Vue, msg) {
    if (isShow) {
      return;
    }
    isShow = true;
    Vue.$bvToast.toast(msg, {
      toaster: 'b-toaster-bottom-center',
      noCloseButton: true,
      autoHideDelay: 2000,
      appendToast: false,
    });


    setTimeout(() => {
      isShow = false;
    }, Math.max(0, 2000));

  },
  formatNumber1: function(value) {
    let num_pattern = /^(\d+)\.?(\d*)$/g
    let result = value
    if (!num_pattern.test(value)) {
      result = value.substr(0, value.length - 1);
    }
    return result;
  },
  formatPhoneNumber: function(phone) {
    if (!phone) {
      return '';
    }

    let phoneNum = phone.replace(new RegExp('[^\\d-]', 'g'), '');
    if (phoneNum.length >= 4 && phoneNum[3] !== '-') {
      phoneNum = phoneNum.substr(0, 3) + '-' + phoneNum.substr(3);
    }
    if (phoneNum.length >= 9 && phoneNum[8] !== '-') {
      phoneNum = phoneNum.substr(0, 8) + '-' + phoneNum.substr(8);
    }
    return phoneNum;
  },

  showConfirm(context, string){
    string = '<span class="confirm_title">' + string +"</span>";
    const msg = context.$createElement('div', { domProps: { innerHTML: string } })
    return context.$bvModal.msgBoxConfirm([msg], {
      dialogClass:"modal-dialog2",
      contentClass:"md-confirm-content",
      hideHeader: true,
      bodyClass: "confirm-body",
      footerClass: "confirm-footer",
      okTitle: i18n.t('common.ok'),
      cancelTitle: i18n.t('common.cancel1'),
      okVariant: "primary md_btn_primary",
      cancelVariant: "secondary md_btn_light",
      centered: true,
    });
  },
  showConfirm2(context, string){
    string = '<span class="confirm_title2">' + string +"</span>";
    const msg = context.$createElement('div', { domProps: { innerHTML: string } })
    return context.$bvModal.msgBoxConfirm([msg], {
      dialogClass:"modal-dialog2",
      contentClass:"md-confirm-content",
      hideHeader: true,
      bodyClass: "confirm-body",
      footerClass: "confirm-footer",
      okTitle: i18n.t('common.ok'),
      cancelTitle: i18n.t('common.cancel1'),
      okVariant: "primary md_btn_primary",
      cancelVariant: "secondary md_btn_light",
      centered: true,
    });
  },
  showConfirm3(context, string){
    string = '<span class="confirm_title2">' + string +"</span>";
    const msg = context.$createElement('div', { domProps: { innerHTML: string } })
    return context.$bvModal.msgBoxConfirm([msg], {
      dialogClass:"modal-dialog2",
      contentClass:"md-confirm-content",
      hideHeader: true,
      bodyClass: "confirm-body",
      footerClass: "confirm-no-footer",
      okTitle: i18n.t('common.ok'),
      cancelTitle: i18n.t('common.cancel1'),
      okVariant: "primary md_btn_primary",
      cancelVariant: "secondary md_btn_light",
      centered: true
    });
  },
  isEmptyOrNull(str) {
    return str == null || str === '' || str === undefined;
  },
  pad(value, count) {
    let string = value.toString();
    return '0'.repeat(Math.max(0, count - string.length)) + string;
  },
  getAddress(item, isFull=false){
    let address = "";
    if (item.f_address1.split(' ').length == 4) {
      address =  (item.f_address1.split(' '))[2] + " " + (item.f_address1.split(' '))[3];
    } else if (item.f_address1.split(' ').length == 5) {
      address =  (item.f_address1.split(' '))[3] + " " + (item.f_address1.split(' '))[4];
    } else if (item.f_address1.split(' ').length == 6) {
      address =  (item.f_address1.split(' '))[3] + " " + (item.f_address1.split(' '))[4] + " " + (item.f_address1.split(' '))[5];
    }
    return isFull ? item.f_address1 : address;
  },

  openURL(url){
    window.location.href = url;
  },
  // getProfile() {
  //   Utils.requestGet(
  //     this.$c.API.User.getProfile,
  //     {}
  //   ).then(result => {
  //     if (result.code === this.$c.API_RES_CODE.SUCCESS) {
  //       this.myinfo.transformData(result.data);
  //       this.myinfo.saveInfo();
  //       this.myinfo.loadInfo();
  //     } else {
  //     }
  //   });
  // },
  isEmpty(value) {
    return typeof value === 'undefined' || value == null || value === '' || Object.keys(value).length === 0;
  },

  async setState(Vue, state, callback=null)
  {
    if (typeof state === "function")
      await state();
    else
      await Object.keys(state).forEach((key, index) => {
        Vue[key] = state[key]
      });
    if (callback)
      callback();
  },

  navigate(context, url){
    if(context.$router.currentRoute.fullPath != url)
      context.$router.push(url);
  },
  callPhone(context, phoneNumber, name)
  {
    //TODO: 전화하기 단추 눌렀을때의 기능 실현
    function handler(event) {
      event.clipboardData.setData('text/plain', name + " " + phoneNumber);
      event.preventDefault();
      document.removeEventListener('copy', handler, true);
    }
    document.addEventListener('copy', handler, true);
    document.execCommand('copy');
    this.toast(context, i18n.t('common.copy_phone_success'));
  },
  onNavi(context, longitude, latitude, address, title) {
    function handler(event) {
      event.clipboardData.setData('text/plain', address);
      event.preventDefault();
      document.removeEventListener('copy', handler, true);
    }
    document.addEventListener('copy', handler, true);
    document.execCommand('copy');
    this.toast(context, i18n.t('common.copy_address_success'));
    window.open("https://map.kakao.com/link/map/" + title + "," + latitude + "," + longitude);
  },
  copyAddress(context, longitude, latitude, address) {
    function handler(event) {
      event.clipboardData.setData('text/plain', address);
      event.preventDefault();
      document.removeEventListener('copy', handler, true);
    }
    document.addEventListener('copy', handler, true);
    document.execCommand('copy');
    this.toast(context, i18n.t('common.copy_address_success'));
  },
  copyAccount(context, account) {
    function handler(event) {
      event.clipboardData.setData('text/plain', account);
      event.preventDefault();
      document.removeEventListener('copy', handler, true);
    }
    document.addEventListener('copy', handler, true);
    document.execCommand('copy');
    this.toast(context, i18n.t('common.copy_account_success'));
  },
  getReportTypeText (type) {
    let result = '';
    if (type == 'SC')
      result = i18n.t('site_report.site_completion');
    if (type == 'SS')
      result = i18n.t('site_report.site_shutdown');
    if (type == 'SR')
      result = i18n.t('site_report.site_resumption');
    if (type == 'STC')
      result = i18n.t('site_report.sales_team_change');
    if (type == 'PC')
      result = i18n.t('site_report.price_change');
    if (type == 'US')
      result = i18n.t('site_report.unregistered_site');
    if (type == 'HC')
      result = i18n.t('site_report.ho_completion');
    if (type == 'HW')
      result = i18n.t('site_report.ho_wrong');
    return result;
  },
  getNumList(max, min=1) {
    let list = [];
    for (let ind = min; ind <= max; ind++) {
      list.push(ind);
    }
    return list;
  },
  getFormatedDateString(date) {
    let year = date.getFullYear();
    let month = ("0" + (1 + date.getMonth())).slice(-2);
    let day = ("0" + date.getDate()).slice(-2);
    let hour = ("0" + date.getHours()).slice(-2);
    let minute = ("0" + date.getMinutes()).slice(-2);
    let second = ("0" + date.getSeconds()).slice(-2);

    return year + month + day + hour + minute + second;
  },
  getCurrentTime() {
    let date = new Date();

    return this.getFormatedDateString(date);
  },
  getTimeAfter8Hour() {
    let date = new Date();
    date.setHours(date.getHours() + 8);

    return this.getFormatedDateString(date);
  },

};



// WEBPACK FOOTER //
// ./src/config/utils.js